export default {
  courseReport:[],
  lessonReport: [],
}
